import axios from 'axios'

import { RequestQuery, Response, WithFilter } from '@models/apiBase'
import { InsuranceModel } from '@models/insurance'

import { API_URL } from '@/constants/constant'

type ResponseInsurances = Response<WithFilter<Array<InsuranceModel>>>

interface IInsurancesAPI {
  getOptionsForQueueNumber: (payload: RequestQuery) => Promise<ResponseInsurances>
}

const INSURANCES_URL = `${API_URL}/insurances`

const InsurancesAPI: IInsurancesAPI = {
  getOptionsForQueueNumber: async (payload) => {
    return axios.post(`${INSURANCES_URL}/options/queue-number`, payload).then((r) => r.data)
  },
}

export default InsurancesAPI
